import dayjs from 'dayjs';
import {forwardRef} from 'react';
import type {FieldValues} from 'react-hook-form';

import {PrintHeader} from '@/components/layouts/PrintHeader';
import {PrintLayout} from '@/components/layouts/PrintLayout';

import type {AnyExportDefinition, ExportColumn} from '../types/exportTypes';
import ExportPdfTable from './ExportPdfTable';

export type ExportPrintDocumentProps = {
  definition: AnyExportDefinition;
  records: unknown[];
  options: FieldValues;
  columns: ExportColumn<unknown>[];
};

const ExportPrintDocument = forwardRef<
  HTMLDivElement,
  ExportPrintDocumentProps
>(({definition, records, options, columns}, ref) => (
  <PrintLayout ref={ref}>
    <div className="space-y-3">
      <PrintHeader
        title={definition.label}
        description={definition.describeOptions?.(options)}
        createdAt={dayjs().toISOString()}
      />
      {definition.renderPdf?.(records, options, columns) ?? (
        <ExportPdfTable columns={columns} records={records} />
      )}
    </div>
  </PrintLayout>
));

ExportPrintDocument.displayName = 'ExportPrintDocument';

export default ExportPrintDocument;
